
<main class="main_acquisition">


  <div class="other_contents">

    <div class="contents">
      <!-- PAYMENTS PAYMENTS=========================PAYMENTS PAYMENTS=================PAYMENTS PAYMENTS===========PAYMENTS PAYMENTS -->
      <div class="payment_module">
        <div class="form_input">

          <!-- Process payment=========================Process payment===================== -->

          <div class="cost_Surface--form">
            <h2 class="title">Payment</h2>

            <form [formGroup]="paymentForm">
              <label for="">Cliamant Type<span class="text-danger">*</span></label>

              <div class="input">
                <mat-select name="item" placeholder="Cliamant Type"
                formControlName="OwnershipTypeId"
                class="default_input reference-form"
                >
                  <mat-option *ngFor="let ownershiptype of ownershiptypes" [value]="ownershiptype.id" (click)="selectOwnershipType(ownershiptype)">
                    {{ownershiptype.OwnershipTypeName}}
                  </mat-option>
                </mat-select>
              </div>

              <div class="input">
                <label for="">Claimant/Beneficiary<span class="text-danger">*</span></label>
                <input type="text"
                placeholder="Search Owner"
                aria-label="Number"
                formControlName="ownerName"
                matInput
                class="default_input reference-form"
                [matAutocomplete]="auto" #name (keyup)="searchAddressbook(name.value)" >

                <mat-autocomplete autoActiveFirstOption  #auto="matAutocomplete">
                  <mat-option *ngFor="let addressbook of addressbooks"
                   (click)="selectaddressbook(addressbook)" [value]="addressbook.Name">
                    <span>{{addressbook.Name}}</span>
                  </mat-option>
                </mat-autocomplete>
              </div>

              <div class="input" *ngIf="lessorType !== 'lessorInfo'">
                <label for="">
                  <span *ngIf="PaymentType !== 'Incident'; else DisplayIncident">Land Type</span>
                  <ng-template #DisplayIncident>Asset Type</ng-template>

                  <span class="text-danger">*</span></label>
                <mat-select name="item" [placeholder]=" PaymentType !== 'Incident' ? 'Land Type' : 'Asset Type'"
                formControlName="LandType"
                class="default_input reference-form"
                >
                  <mat-option *ngFor="let terrain of terrains" [value]="terrain.id" (click)="selectTerrain(terrain)">
                    {{terrain.TerrainName}}
                  </mat-option>
                </mat-select>
              </div>

              <div class="input">
                <label for="">Item Description<span class="text-danger">*</span></label>
               <input  type="text" class="default_input reference-form" formControlName="ItemName" (click)="onLossOfUseDialog('lossOfUse')">
                <!-- <mat-select name="item"
                class="default_input reference-form"
                formControlName="ItemName">
                  <mat-option *ngFor="let item of lossofuseitems" [value]="item.LossOfUseItemDesc" (click)="selectLossOfItem(item)">
                    {{item.LossOfUseItemDesc}}
                  </mat-option>
                </mat-select> -->
              </div>
              <div class="input" *ngIf="PaymentType === 'Incident'">
                <label for="">Quantum of Impact</label>
                <mat-select  name="item"
                class="default_input reference-form"
                formControlName="IncidentQuantumId">
                  <mat-option *ngFor="let quantum of quantums" [value]="quantum.id" (click)=" selectImpact(quantum) ">
                    {{quantum.IncidentQuantumName}}
                  </mat-option>
                </mat-select>
              </div>



              <div class="input">
                <label for="">Area <span class="text-danger">*</span></label>
               <input  type="number" class="default_input reference-form" formControlName="Area"(input)="calcAmount()">
              </div>

              <div class="input">
                <label for="">Rate <span class="text-danger">*</span></label>
                <input type="number" class="default_input reference-form" formControlName="Rate"/>
              </div>


              <div class="input">
                <label for="">Amount <span class="text-danger">*</span></label>
                <input type="number" class="default_input reference-form" readonly formControlName="Amount"/>
              </div>


              <div class="input">
                <label for="">Negotiated Amount <span class="text-danger">*</span></label>
                <input type="number" class="default_input reference-form"  formControlName="NegotiatedAmount"/>
              </div>
              <div class="input" *ngIf="PaymentType === 'Incident'">
                <label for="">RDF</label>
                <input formControlName="Rdf" type="checkbox" class="default_input reference-form" />
              </div>

              <div class="input">
                <label for="">Remark</label>
                <input type="text" class="default_input reference-form" formControlName="Remarks" />
              </div>
              <!-- <pre>{{paymentForm.value | json}}</pre> -->
            </form>
          </div>
          <div class="btn_holder">
            <button class="default_primary-button" (click)="savePayment(paymentForm.value)">Save Payment</button>
          </div>
        </div>
        <!-- right side=========================================right side -->
        <div class="soln">
          <div class="tab_top">
            <div class="summary">
              <p class="total_summary">
                <span>Total:</span>
                <span class="amount" style="color: rgb(199, 38, 38);"> {{calcTotal().totalAmount | number:'1.2'}} </span>
              </p>
              <p class="negotiated_summary">
                <span>Negotiated Amt:</span>
                <span class="amount" style="color: rgb(199, 38, 38);"> {{calcTotal().totalNegotiated | number:'1.2'}} </span>
              </p>
              <p class="difference_summary">
                <span>Difference:</span>
                <span class="amount" style="color: rgb(201, 46, 46);"> {{(calcTotal().totalAmount - calcTotal().totalNegotiated) | number:'1.2'}} </span>
              </p>
            </div>

            <div class="tab_buttons-new" *ngIf="PaymentType !== 'Incident'">

                <button class="active" (click)="onLessorDialog('lessorInfo')">Lessors</button>
                <button (click)="onLessorDialog('representative')">Representatives</button>
                <button (click)="onLessorDialog('stakeholder')">Stakeholders</button>

            </div>

          </div>

          <div class="payment_tab">

            <div class="toggle_payment_view">
              <mat-button-toggle-group
            name="fontStyle"
            aria-label="Font Style"
            color="accent"
            class="m-3"

            >
            <mat-button-toggle value="list" color="accent" (click)="onList()"
              ><mat-icon class="example-tab-icon"
                >list</mat-icon
              ></mat-button-toggle
            >
            <mat-button-toggle value="grid" (click)="onGrid()"
              ><mat-icon class="example-tab-icon"
                >view_module</mat-icon
              ></mat-button-toggle
            >
            </mat-button-toggle-group>
            </div>


            <!-- PROCESS PAYMENT========================PROCESS PAYMENT=====================PROCESS PAYMENT========= -->
            <ng-container *ngIf="gridView">
            <div class="tab_content">
              <div class="pay_content">
                  <div class="entry"  *ngFor="let lessor of filteredPayment; index as i" (click)="selectPayment(lessor)">
                    <p class="top_entry--info"><span>.{{i + 1}}</span></p>
                    <p class="info"><span>OwnershipType: </span>{{lessor.OwnershipTypeName}}</p>
                    <p class="info"><span>Owner: </span>{{lessor.ownerName}}</p>
                    <!-- <p class="info"><span>Item: </span>{{lessor.ItemName}}</p> -->
                    <p class="info"><span>Item Description: </span> {{lessor.ItemName}}</p>
                    <p class="info"><span>LandType: </span>{{lessor.TerrianName}}</p>
                    <p class="info" *ngIf="getImpact(lessor)" ><span>Quatom of Impact: </span> {{getImpact(lessor).IncidentQuantumName}}</p>
                    <p class="info"><span>Area: </span>{{lessor.Area}}</p>
                    <p class="info"><span>Rate: </span>{{lessor.Rate}}</p>
                    <p class="info"><span>Uom: </span>{{getUomName(lessor?.UomId)}}</p>
                    <p class="info" *ngIf="PaymentType === 'Incident'"><span>DF: </span>{{lessor.DistributorFactorName}}</p>
                    <p class="info"><span>Actual Amt: </span>{{lessor.Amount | number:'1.2'}}</p>
                    <p class="info"><span>Negotiated Amt: </span>{{lessor.NegotiatedAmount | number:'1.2'}}</p>
                    <p class="info"><span>Remark: </span>{{lessor.Remarks}}</p>
                    <p class="info"><span>Approval Remark: </span>{{lessor.ApprovalRemarks}}</p>
                    <p class="info"><span>Status: </span>{{lessor.PaymentStatus}}</p>
                    <p class="info" *ngIf="PaymentType === 'Incident'"><span>RDF: </span><input type="checkbox" [checked]="lessor.Rdf" /></p>
                    <button mat-icon-button (click)="deleteLessor(lessor); $event.stopImmediatePropagation()" class="text-danger" [disabled]="lessor?.PaymentStatus.includes('PAID')"> <i class="ti-trash"></i></button>
                </div>
              </div>
            </div>
          </ng-container>

            <div class="card mt-3 " *ngIf="listView">
              <div class="table-responsive">
              <table class="table table-hover" >
                <thead>
                  <tr>
                    <th scope="col">S/N</th>
                    <th scope="col">OwnershipType</th>
                    <th scope="col">Owner</th>
                    <!-- <th scope="col">Item</th> -->
                    <th scope="col">Item Description</th>
                    <th scope="col">LandType</th>
                    <th scope="col" *ngIf="PaymentType === 'Incident'">Quatom of Impact</th>
                    <th scope="col">Area</th>
                    <th scope="col">Rate</th>
                    <th scope="col">UOM</th>
                    <th scope="col" *ngIf="PaymentType === 'Incident'">DF</th>
                    <th scope="col">Actual Amt</th>
                    <th scope="col">Negotiated Amt</th>
                    <th scope="col">Remark</th>
                    <th scope="col">Approval Remark</th>
                    <th scope="col">Status</th>
                    <th scope="col" *ngIf="PaymentType === 'Incident'">RDF</th>
                    <th scope="col">Actions</th>
                  </tr>
                </thead>
                <tbody >
                  <tr   *ngFor="let lessor of filteredPayment; index as i" (click)="selectPayment(lessor)"
                  style="cursor: pointer;"
                  >
                    <th scope="row">{{i + 1}}</th>
                    <td>{{lessor.OwnershipTypeName}}</td>
                    <td>{{lessor.ownerName}}</td>
                    <td> {{lessor.ItemName}}</td>
                    <td>{{lessor.TerrianName}}</td>
                    <td *ngIf="PaymentType === 'Incident'">{{getImpact(lessor)?.IncidentQuantumName}}</td>
                    <td>{{lessor.Area}}</td>
                    <td>{{lessor.Rate}}</td>
                    <td>{{getUomName(lessor?.UomId)}}</td>
                    <td *ngIf="PaymentType === 'Incident'">{{lessor.DistributorFactorName}}</td>
                    <td>{{lessor.Amount | number:'1.2'}}</td>
                    <td>{{lessor.NegotiatedAmount | number:'1.2'}}</td>
                    <td>{{lessor.Remarks}}</td>
                    <td>{{lessor.ApprovalRemarks}}</td>
                    <td>{{lessor.PaymentStatus}}</td>
                    <td *ngIf="PaymentType === 'Incident'"> <input type="checkbox" [checked]="lessor.Rdf" /></td>

                    <td (click)="$event.stopImmediatePropagation()" style="cursor: pointer;">
                      <i class="ti-trash" [hidden]="lessor?.PaymentStatus.includes('PAID')" (click)="deleteLessor(lessor);"></i>
                     </td>
                  </tr>

                </tbody>
              </table>
            </div>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>

  <!-- search popup=========================================search popup -->


  <div class="submit">
    <button class="default_primary-button" (click)="onSubmit(filteredPayment)">Submit Payment</button>
  </div>
</main>
